var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWtjc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#144CD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.88 23.437a6.259 6.259 0 10-1.424 1.3l1.368 1.368-.206.204a.674.674 0 000 .953l2.134 2.134c-4.512 3.217-10.818 2.8-14.867-1.249-4.512-4.512-4.512-11.829 0-16.341 4.514-4.515 11.83-4.515 16.342-.001 4.049 4.048 4.466 10.354 1.25 14.866l-2.134-2.134a.675.675 0 00-.954 0l-.204.204-1.305-1.304zm-4.88.415a4.334 4.334 0 110-8.67 4.334 4.334 0 010 8.67z",
    fill: "#fff"
  })));
}
export default SvgWtjc;